import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  Button,
  Alert,
  Typography,
  Container,
  IconButton,
  Paper
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { useNavigate } from "react-router-dom";

// Importación de tus configuraciones
import { 
  API_BASE_URL, 
  LOGIN, 
  TIEMPOEXPIRACIONCOOKIEENMINUTOS,
  COLORSISTEMA 
} from '../services/apiConfig';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post(API_BASE_URL + LOGIN, {
        email: email,
        password: password,
      })
      .then((response) => {
        if (response.data.status === "success") {
          // 1. Guardamos estado básico
          sessionStorage.setItem("loggedIn", "true");
          
          // 2. Guardamos la info del usuario
          sessionStorage.setItem("userData", JSON.stringify(response.data.data));
          
          // 3. Guardamos el JWT
          const token = response.data.data.token;
          sessionStorage.setItem("authToken", token);

          // 4. Calculamos expiración para control interno
          const maxAge = TIEMPOEXPIRACIONCOOKIEENMINUTOS * 60;
          const expiryTime = new Date().getTime() + maxAge * 1000;
          sessionStorage.setItem("expiryTime", expiryTime);

          navigate("/dashboard");
        } else {
          setError(response.data.message);
        }
      })
      .catch((err) => {
        setError("Error de conexión con el servidor");
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8", // Color de fondo sutil
      }}
    >
      <Container maxWidth="xs">
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            borderRadius: 2
          }}
        >
          {/* SECCIÓN DE LA IMAGEN / LOGO */}
          

          <Typography
            sx={{ 
                mb: 3, 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                fontWeight: 'bold',
                color: COLORSISTEMA 
            }}
            variant="h4"
            component="h1"
          >
            <PointOfSaleIcon sx={{ fontSize: 40 }} /> Administración
          </Typography>

          {error && (
            <Alert sx={{ mb: 2, width: '100%' }} severity="error">
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <TextField
              type="email"
              value={email}
              onChange={handleEmailChange}
              variant="outlined"
              id="email"
              label="Correo Electrónico"
              fullWidth
              required
              sx={{ mb: 2 }}
            />

            <TextField
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              variant="outlined"
              id="password"
              label="Contraseña"
              fullWidth
              required
              sx={{ mb: 3 }}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={handleShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
            />

            <Button
              variant="contained"
              type="submit"
              fullWidth
              size="large"
              sx={{
                backgroundColor: COLORSISTEMA,
                py: 1.5,
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: COLORSISTEMA,
                  filter: 'brightness(0.9)'
                },
              }}
            >
              Iniciar Sesión
            </Button>
          </form>

          <Typography variant="body2" color="textSecondary" sx={{ mt: 3 }}>
            © {new Date().getFullYear()} Zure Locales 
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Login;